'use strict';
import React from 'react';


class Loading extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        let content = "";

        if (this.props.processing) {
            content = (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            );
        }
        return (
            <div>
                {content}
            </div>
        );
    }
}
export default Loading;


// WEBPACK FOOTER //
// ./app/components/loading.js